module.exports = __webpack_public_path__ + "static/media/2007.b842ff1e.png";